<div
	class="jepto-card-query-status__body"
	[class.jepto-card-query-status__body--error]="kind() === 'error'"
	[attr.data-testid]="testId() ?? null"
>
	<div class="jepto-card-query-status__icon" aria-hidden="true">
		<mat-icon class="material-symbols-outlined">{{ icon() }}</mat-icon>
	</div>
	<div class="jepto-card-query-status__copy">
		<p class="jepto-card-query-status__title">{{ copy().title }}</p>
		<p class="jepto-card-query-status__subtitle">{{ copy().subtitle }}</p>
	</div>
	<button
		type="button"
		class="jepto-card-query-status__refresh"
		(click)="onRefresh($event)"
	>
		<span>Refresh Data</span>
		<mat-icon class="material-symbols-outlined">autorenew</mat-icon>
	</button>
</div>
